module.exports = __webpack_public_path__ + "img/mark.67d80a4f.png";